import { combineReducers } from 'redux';
import app from './app';
import auth from './auth';
import dashboard from './dashboard';
import business from './business';
import carriers from './carriers';
import greeting from './greeting';
import softwares from './softwares';
import softwareRequest from './softwareRequest';
import voicemails from './voicemails';
import preferences from './preferences';
import billing from './billing';
import domain from './domain';
import staff from './staff';
import services from './services';
import schedules from './schedules';
import help from './help';
import conversations from './conversations';
import Outreaches from './outreach';
import webchatconfig from './webchat';
import Formresponse from './formresponse';
import StaffManagement from './staffmanagement';
import staffmapping from './staffmapping';
import webbookingconfig from './webbooking';
import AppointmentReminder from './AppointmentReminder';
import analytics from './analytics';
import aiAssistConfigReducer from './aiAssistConfigReducer';
import VoiceAIConfig from './voiceaiconfig';

const topLevelReducer = combineReducers({
  app,
  auth,
  dashboard,
  business,
  carriers,
  greeting,
  softwares,
  softwareRequest,
  voicemails,
  preferences,
  billing,
  domain,
  staff,
  services,
  schedules,
  help,
  conversations,
  Outreaches,
  webchatconfig,
  Formresponse,
  StaffManagement,
  webbookingconfig,
  AppointmentReminder,
  staffmapping,
  analytics,
  aiAssistConfigReducer,
  VoiceAIConfig,
});

export default (state, action) => {
  if (action.type === 'LOGOUT_USER' || action.type === 'LOGIN_USER_START') {
    return topLevelReducer(undefined, action);
  }

  return topLevelReducer(state, action);
};
